/**
 * Helpers puros del Historial de PSI+ (trimestres cobrados y trimestres cerrados sin bono).
 */

const MONTHS = [
  'Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio',
  'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre',
];

/** "Q3 2026 — Julio a Septiembre". */
export function formatQuarterLabel(quarterYear: number, quarter: number): string {
  const startMonth = (quarter - 1) * 3;
  return `Q${quarter} ${quarterYear} — ${MONTHS[startMonth]} a ${MONTHS[startMonth + 2]}`;
}

export interface HistorialSinBonoSummary {
  totalEligibleUniverse5: number;
  totalEligibleUniverse10: number;
  minSessionsRequired: number;
  missingSessions: number;
}

/** Texto corto de por qué un trimestre cerrado no llegó al primer bono. */
export function explainSinBono(s: HistorialSinBonoSummary): string {
  const sesiones = s.totalEligibleUniverse5 === 1 ? 'sesión ponderada' : 'sesiones ponderadas';
  const faltaron = s.missingSessions === 1 ? 'Te faltó 1 sesión' : `Te faltaron ${s.missingSessions} sesiones`;
  return `Tuviste ${s.totalEligibleUniverse5} ${sesiones} y el mínimo para el primer bono es ${s.minSessionsRequired}. ${faltaron}.`;
}

/**
 * Mensaje para animar a llegar el próximo trimestre. Si estuvo cerca (a 25 sesiones o menos del
 * mínimo) lo dice; si no, igual marca que el trimestre nuevo empieza de cero y que los procesos
 * que ya pasaron la 5ª sesión suman desde la primera sesión (la cuenta es acumulada por proceso).
 */
export function motivacionSinBono(s: Pick<HistorialSinBonoSummary, 'missingSessions'>): string {
  const cerca = s.missingSessions <= 25
    ? '¡Estuviste muy cerca! '
    : 'Cada trimestre es una nueva oportunidad. ';
  return `${cerca}El próximo trimestre arranca de cero y los procesos que ya pasaron su 5ª sesión suman desde la primera sesión que tengas: con tus procesos en marcha podés llegar al bono.`;
}

/** "Ana Paz" / "Ana Paz y Luis Gómez" / "Sin nombre". */
export function formatPatientNames(names: string[]): string {
  if (names.length === 0) return 'Sin nombre';
  if (names.length === 1) return names[0];
  return `${names.slice(0, -1).join(', ')} y ${names[names.length - 1]}`;
}
